<template>
    <div class="page m-liveHost">
        <div class="main">
            <div class="live-header">

                <el-button class="btn-add" @click="addHost" type="primary" size="small" icon="el-icon-circle-plus-outline">
                     创建直播
                </el-button>

                <div class="live-filter">
                    <el-select v-model="formSearch.status"
                               placeholder="选择直播状态"
                               size="small"
                               @change="getLiveRooms"
                               clearable>
                        <el-option label="直播中" :value="1"></el-option>
                        <el-option label="预告" :value="2"></el-option>
                        <el-option label="结束" :value="3"></el-option>
                        <!--                        <el-option label="点播" :value="4"></el-option>-->
                        <el-option label="回放" :value="5"></el-option>
                    </el-select>

                    <el-select v-model="formSearch.topicsName"
                               placeholder="选择直播话题"
                               size="small"
                               @change="getLiveRooms"
                               clearable>
                        <el-option v-for="item in topicList"
                                   :key="item"
                                   :label="item.topicName"
                                   :value="item.topicName">
                            <span style="float: left">{{ item.topicName }}</span>
                            <span style="float: right; color: #8492a6; font-size: 12px">（{{ item.count }}）</span>
                        </el-option>
                    </el-select>

                    <el-switch
                        v-model="formSearch.onlyMine"
                        v-permission="[1, 4]"
                        active-text="我的直播"
                        inactive-text="全部直播"
                        @change="getLiveRooms"
                    >
                    </el-switch>
                </div>

            </div>

            <room-list
                :data="liveRooms"
                @host-start="startHost"
                @host-edit="editHost"
                @host-delete="deleteHost"
                @host-detail="toHostDetail"
            ></room-list>
        </div>

        <transition enter-active-class="animated zoomIn"
                    leave-active-class="animated zoomOutUp">
            <router-view @onClose="onSubpageClose"></router-view>
        </transition>
    </div>
</template>

<script>
/**
 * todo:
 * 1、进入时页面闪动的问题
 */
import RoomList from "./Components/RoomList";
import {Ticket} from '@/utils';

export default {
    components: {
        RoomList
    },

    data() {
        return {
            formSearch: {
                status: '',
                topicsName: '',
                onlyMine: false
            },
            liveRooms: [],
            topicList: []
        }
    },

    computed: {

    },

    mounted() {
        this.getTopicList()

        this.getLiveRooms()
    },

    methods: {
        async getTopicList() {
            let res = await this.$api.getLiveTopicListUsed()
            let data = res.package
            this.topicList = data
        },

        async getLiveRooms() {
            let queryData = {...this.formSearch}

            let userType = Ticket.get().type
            if (![1, 4].includes(userType)) {
                delete queryData.onlyMine
            }

            let res = await this.$api.getMyLiveRooms(queryData)
            let data = res.package
            this.liveRooms = data
            //this.liveRooms = [...data,...data,...data,...data]
        },

        // 开始直播
        startHost(id) {
            window.open(`/live/publish/${id}`)

            //this.$router.push({name: 'livePublish', params: {id}})
        },

        addHost() {
            this.$router.push({name: 'liveHostAdd'})
        },

        // 修改直播间
        editHost(id) {
            this.$router.push({name: 'liveHostDetail', params: {id, action:'edit'}})
        },

        // 直播间详情页
        toHostDetail(id) {
            this.$router.push({name: 'liveHostDetail', params: {id, action:'view'}})
        },

        // 删除直播间
        async deleteHost(id) {
            await this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {type: 'warning'})
            await this.$api.deleteLiveRoom(id)
            this.$message.success(this.$t('m.delSuccess'))
            this.getLiveRooms()
        },

        onSubpageClose() {
            this.getTopicList()
            this.getLiveRooms()
        }
    },
}
</script>

<style scoped lang="scss">
    .m-liveHost {
        display: block;
    }

    .main {
        min-height: 100%;
        padding: 12px 20px;
        background-color: #fff;
        box-shadow: 0 0 15px #e1e0d8;
    }

    .live-header {
        padding: 15px;
        display: flex;
        justify-content: space-between;

        .btn-add {
            /deep/ i {
                font-size: 15px;
            }
        }

        .input-title {
            width: 220px;
            margin-left: 20px;
        }
    }

    .live-filter {
        .el-select + .el-select {
            margin-left: 15px;
        }
        .el-switch {
            margin-left: 15px;
        }
    }

    .live-list {

    }
</style>
